// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Imported from:
https://github.com/forkphorus/forkphorus/tree/master/studioview
With changes to make it work properly in the scratch-gui environment.
*/

/* we wrap it in a <div> */

.studioview_wrapper_XE2Bf {
  height: 100%;
}

/* fix some styles that can be messed up by scratch-gui */

.studioview_studioview-root_u0yPZ * {
  box-sizing: content-box !important;
}

.studioview_studioview-root_u0yPZ {
  height: 100%;
}

.studioview_studioview-list_YEy0z {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-anchor: none;
}

.studioview_studioview-project_kTC07, .studioview_studioview-placeholder_UxIpK {
  display: inline-block;
  width: 144px;
  padding: 3px;
  margin-bottom: 1px;
  margin-right: 1px;
}

.studioview_studioview-root_u0yPZ .studioview_studioview-project_kTC07 {
  color: inherit;
  position: relative;
  text-decoration: none;
}

.studioview_studioview-loaded_bOBAN:hover::before, .studioview_studioview-loaded_bOBAN:active::before {
  content: '';
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: currentColor;
  opacity: 0.1;
}

.studioview_studioview-root_u0yPZ .studioview_studioview-loaded_bOBAN:active::before {
  opacity: 0.2;
}

.studioview_studioview-root_u0yPZ .studioview_studioview-title_Oy5EY,
.studioview_studioview-root_u0yPZ .studioview_studioview-author_Ocyf8 {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
}

.studioview_studioview-title_Oy5EY {
  font-size: 0.8em;
  font-weight: bold;
}

.studioview_studioview-author_Ocyf8 {
  font-size: 0.75em;
}

.studioview_studioview-error_vEGyW {
  width: 100%;
}

.studioview_studioview-thumbnail_NMwWq, .studioview_studioview-placeholder-thumbnail_KqY1g {
  position: relative;
  width: 144px;
  height: 108px;
}

.studioview_studioview-thumbnail_NMwWq::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: currentColor;
  opacity: 0.1;
}

.studioview_studioview-thumbnail_NMwWq img {
  width: 100%;
  height: 100%;
}

.studioview_studioview-placeholder_UxIpK .studioview_studioview-thumbnail_NMwWq,
.studioview_studioview-placeholder_UxIpK .studioview_studioview-title_Oy5EY,
.studioview_studioview-placeholder_UxIpK .studioview_studioview-author_Ocyf8 {
  background-color: currentColor;
  opacity: 0.1;
}

.studioview_studioview-title_Oy5EY {
  height: 20px;
  margin-top: 2px;
}

.studioview_studioview-author_Ocyf8 {
  height: 18px;
}

.studioview_studioview-placeholder_UxIpK .studioview_studioview-title_Oy5EY {
  border-radius: 2px 2px 2px 0;
  width: 100%;
}

.studioview_studioview-placeholder_UxIpK .studioview_studioview-author_Ocyf8 {
  border-radius: 0 0 2px 2px;
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-studioview/studioview.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED,0BAA0B;;AAE1B;EACE,YAAY;AACd;;AAEA,yDAAyD;;AAEzD;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ","sourcesContent":["/*\nImported from:\nhttps://github.com/forkphorus/forkphorus/tree/master/studioview\nWith changes to make it work properly in the scratch-gui environment.\n*/\n\n/* we wrap it in a <div> */\n\n.wrapper {\n  height: 100%;\n}\n\n/* fix some styles that can be messed up by scratch-gui */\n\n.studioview-root * {\n  box-sizing: content-box !important;\n}\n\n.studioview-root {\n  height: 100%;\n}\n\n.studioview-list {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-anchor: none;\n}\n\n.studioview-project, .studioview-placeholder {\n  display: inline-block;\n  width: 144px;\n  padding: 3px;\n  margin-bottom: 1px;\n  margin-right: 1px;\n}\n\n.studioview-root .studioview-project {\n  color: inherit;\n  position: relative;\n  text-decoration: none;\n}\n\n.studioview-loaded:hover::before, .studioview-loaded:active::before {\n  content: '';\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.studioview-root .studioview-loaded:active::before {\n  opacity: 0.2;\n}\n\n.studioview-root .studioview-title,\n.studioview-root .studioview-author {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  color: inherit;\n  text-decoration: none;\n}\n\n.studioview-title {\n  font-size: 0.8em;\n  font-weight: bold;\n}\n\n.studioview-author {\n  font-size: 0.75em;\n}\n\n.studioview-error {\n  width: 100%;\n}\n\n.studioview-thumbnail, .studioview-placeholder-thumbnail {\n  position: relative;\n  width: 144px;\n  height: 108px;\n}\n\n.studioview-thumbnail::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.studioview-thumbnail img {\n  width: 100%;\n  height: 100%;\n}\n\n.studioview-placeholder .studioview-thumbnail,\n.studioview-placeholder .studioview-title,\n.studioview-placeholder .studioview-author {\n  background-color: currentColor;\n  opacity: 0.1;\n}\n\n.studioview-title {\n  height: 20px;\n  margin-top: 2px;\n}\n\n.studioview-author {\n  height: 18px;\n}\n\n.studioview-placeholder .studioview-title {\n  border-radius: 2px 2px 2px 0;\n  width: 100%;\n}\n\n.studioview-placeholder .studioview-author {\n  border-radius: 0 0 2px 2px;\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `studioview_wrapper_XE2Bf`,
	"studioview-root": `studioview_studioview-root_u0yPZ`,
	"studioviewRoot": `studioview_studioview-root_u0yPZ`,
	"studioview-list": `studioview_studioview-list_YEy0z`,
	"studioviewList": `studioview_studioview-list_YEy0z`,
	"studioview-project": `studioview_studioview-project_kTC07`,
	"studioviewProject": `studioview_studioview-project_kTC07`,
	"studioview-placeholder": `studioview_studioview-placeholder_UxIpK`,
	"studioviewPlaceholder": `studioview_studioview-placeholder_UxIpK`,
	"studioview-loaded": `studioview_studioview-loaded_bOBAN`,
	"studioviewLoaded": `studioview_studioview-loaded_bOBAN`,
	"studioview-title": `studioview_studioview-title_Oy5EY`,
	"studioviewTitle": `studioview_studioview-title_Oy5EY`,
	"studioview-author": `studioview_studioview-author_Ocyf8`,
	"studioviewAuthor": `studioview_studioview-author_Ocyf8`,
	"studioview-error": `studioview_studioview-error_vEGyW`,
	"studioviewError": `studioview_studioview-error_vEGyW`,
	"studioview-thumbnail": `studioview_studioview-thumbnail_NMwWq`,
	"studioviewThumbnail": `studioview_studioview-thumbnail_NMwWq`,
	"studioview-placeholder-thumbnail": `studioview_studioview-placeholder-thumbnail_KqY1g`,
	"studioviewPlaceholderThumbnail": `studioview_studioview-placeholder-thumbnail_KqY1g`
};
export default ___CSS_LOADER_EXPORT___;
